module.exports = __webpack_public_path__ + "static/media/fill_circle.6b0b0178.svg";